import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type CustomerType = 'private' | 'business';

interface CustomerTypeStore {
  customerType: CustomerType;
  hasChosen: boolean;
  setCustomerType: (type: CustomerType) => void;
  reset: () => void;
}

export const useCustomerTypeStore = create<CustomerTypeStore>()(
  persist(
    (set) => ({
      customerType: 'private',
      hasChosen: false,

      setCustomerType: (type) => {
        set({ customerType: type, hasChosen: true });
      },

      reset: () => {
        set({ customerType: 'private', hasChosen: false });
      },
    }),
    {
      name: 'autofrance-customer-type',
    }
  )
);
